import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import { DefaultReplyType, defaultReplySchema } from 'shared/api/common/schemas/flow/defaultReply'

export const defaultReplyApiSchemas = {
  getData: {
    query: z.object({
      channel: z.nativeEnum(ChannelType),
    }),
    path: z.undefined(),
    response: defaultReplySchema,
  },
  switch: {
    query: z.object({
      channel: z.nativeEnum(ChannelType),
      default_enabled: z.number(),
    }),
    path: z.undefined(),
    response: defaultReplySchema,
  },
  changeType: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.nativeEnum(ChannelType),
      type: z.nativeEnum(DefaultReplyType),
    }),
    response: defaultReplySchema,
  },
  replaceFlow: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.nativeEnum(ChannelType),
      flow_ns: z.string().nullable().optional(),
    }),
    response: defaultReplySchema,
  },
  changeSource: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.nativeEnum(ChannelType),
      sources: z.object({
        direct: z.boolean(),
        story: z.boolean(),
      }),
    }),
    response: defaultReplySchema,
  },
  removeFlow: {
    query: z.undefined(),
    path: z.undefined(),
    request: z.object({
      channel: z.nativeEnum(ChannelType),
    }),
    response: defaultReplySchema,
  },
}
